import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { ApiError, http } from '../../api/client';
import { Alert, Button, Field } from '../../components/ui';
import { AuthShell } from './AuthShell';

/**
 * „დაგავიწყდა პაროლი?" — ბმულის მოთხოვნა.
 *
 * წარმატების შეტყობინება **ერთი და იგივეა** ყველა შემთხვევაში: არსებობს
 * ანგარიში თუ არა, გამორთულია თუ არა. სხვაგვარად ეს გვერდი ნებისმიერს
 * მისცემდა საშუალებას გადაემოწმებინა, ვინ არის სისტემაში.
 */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await http.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      // 429 ერთადერთი შემთხვევაა, როცა რეალურად რაღაც უნდა ვუთხრათ
      setError(err instanceof ApiError ? err.message : 'მოთხოვნა ვერ გაიგზავნა');
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AuthShell title="ბმული გამოგზავნილია" subtitle="შეამოწმე ელფოსტა">
        <Alert kind="success">
          თუ ასეთი ანგარიში არსებობს, აღდგენის ბმული გამოგზავნილია <b>{email}</b>-ზე.
        </Alert>
        <p className="mt-4 text-[13px] text-ink-mute">
          ბმული ერთ საათს მოქმედებს და მხოლოდ ერთხელ იმუშავებს. თუ წერილი არ მოვიდა,
          შეამოწმე „სპამი" ან მიმართე ადმინისტრატორს.
        </p>
        <Link to="/login">
          <Button variant="secondary" className="mt-4 w-full">
            შესვლის გვერდზე დაბრუნება
          </Button>
        </Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="პაროლის აღდგენა" subtitle="მიუთითე ელფოსტა — გამოგიგზავნით ბმულს">
      <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4">
        {error && <Alert kind="error">{error}</Alert>}

        <Field
          label="ელფოსტა"
          type="email"
          autoComplete="email"
          required
          autoFocus
          placeholder="name@itstep.org"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button type="submit" loading={busy} className="w-full">
          ბმულის გამოგზავნა
        </Button>

        <Link
          to="/login"
          className="block text-center text-[13px] text-ink-mute hover:text-ink"
        >
          შესვლის გვერდზე დაბრუნება
        </Link>
      </form>
    </AuthShell>
  );
}
